import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { IonicStorageModule } from '@ionic/storage-angular';
import { Drivers } from '@ionic/storage';
import { StoreModule } from '@ngrx/store';
import { menuReducer } from './stores/menu/menu.reducers';

import { SQLite } from '@ionic-native/sqlite/ngx';
import { SqliteDbCopy } from '@ionic-native/sqlite-db-copy/ngx';
import { Insomnia } from '@awesome-cordova-plugins/insomnia/ngx';
import { dbReducer } from './stores/db/db.reducers';
import { userReducer } from './stores/user/user.reducers';
import { NgxPubSubModule } from '@pscoped/ngx-pub-sub';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FileTransfer } from '@awesome-cordova-plugins/file-transfer/ngx'
import { File } from '@awesome-cordova-plugins/file/ngx'
import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';

@NgModule({
  declarations: [
    AppComponent
  ],
  entryComponents: [],
  imports: [
    BrowserModule
    , BrowserAnimationsModule
    , IonicModule.forRoot()
    , IonicStorageModule.forRoot({
      name: 'gma',
      driverOrder: [
        , Drivers.IndexedDB
        , Drivers.LocalStorage
      ]
    })
    , StoreModule.forRoot({
      menu: menuReducer,
      db: dbReducer,
      user: userReducer
    })
    , AppRoutingModule
    , NgxPubSubModule
  ],
  providers: [
    SQLite
    , SqliteDbCopy
    , Insomnia
    , FileOpener
    , FileTransfer
    , File
    , BarcodeScanner
    , { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
